module.exports = __webpack_public_path__ + "static/plan-s3-daafe8cdc89f713c3b0845bc1adf36a3.png";